/**
 * Validates if a string is an image url
 * @param url
 */
export const isUrlImage = (url: string): boolean => {
  if (!url) {
    return false;
  }
  return url.includes('https') && /\.(jpg|jpeg|png|wepb)/i.test(url);
};

export const isUrlPdf = (url: string): boolean => {
  if (!url) {
    return false;
  }
  return url.includes('https') && /\.pdf/i.test(url);
};

/**
 * Given base64 string, extract's its mime type
 * @param base64
 */
export const extractMime = (base64: string): string => {
  if (base64 === undefined || base64 === null || base64.length === 0) {
    return '';
  }
  return base64.substring(base64.indexOf(':') + 1, base64.indexOf(';'));
};

/**
 * Given base64 string, checks if it is pdf type
 * @param base64
 */
export const isPdf = (base64: string): boolean => {
  if (base64 === undefined || base64 === null) {
    return false;
  }
  const mimeType = extractMime(base64);
  return mimeType.includes('pdf') || isUrlPdf(base64);
};

/**
 * Given base64 string, checks if it is image type
 * @param base64
 */
export const isImage = (base64: string): boolean => {
  if (base64 === undefined || base64 === null) {
    return false;
  }
  const mimeType = extractMime(base64);
  return mimeType.includes('image') || isUrlImage(base64);
};
